<template>
  <div class="p-8">
    <!-- Header con pulsante aggiungi -->
    <div class="flex justify-end mb-4">
      <button
        @click="openCreate"
        class="flex items-center gap-1 px-3 py-1 rounded-lg border border-primary-800 shadow-sm text-gray-100 bg-primary-600 text-sm">
        <span class="material-icons text-base">add</span>
        Aggiungi profilo
      </button>
    </div>

    <!-- Lista profili -->
    <div v-if="billingProfiles && billingProfiles.length">
      <div v-for="bp in billingProfiles" :key="bp.id" class="mb-6 bg-white rounded-lg shadow p-4">
        <div class="font-bold text-lg p-2 flex justify-between items-center">
          <p>
            {{ $t('billing.billingProfile') }}
            <span class="text-sm font-normal text-gray-500 ml-2">{{ bp.profile_type }}</span>
          </p>
          <div class="flex gap-2">
            <button class="material-icons shadow-md px-1 rounded-lg" :class="bp.favourite ? 'text-yellow-400' : 'text-gray-300'" @click="setFavourite(bp)">star</button>
            <button class="material-icons text-gray-500 shadow-md px-1 rounded-lg" @click="openEdit(bp)">edit</button>
            <button class="material-icons text-red-400 shadow-md px-1 rounded-lg" @click="openDelete(bp)">delete</button>
          </div>
        </div>
        <div class="border-t border-t-gray-400 mt-2 pt-2 grid grid-cols-2 gap-2">
          <div class="text-gray-500">{{ $t('billing.name') }}</div>
          <div>{{ bp.name }}</div>
          <div class="text-gray-500">{{ $t('billing.fiscalCode') }}</div>
          <div>{{ bp.fiscal_code }}</div>
          <div class="text-gray-500">{{ $t('billing.address') }}</div>
          <div>{{ bp.line1 }}</div>
          <div class="text-gray-500">{{ $t('billing.city') }}</div>
          <div>{{ bp.city }}</div>
          <div class="text-gray-500">{{ $t('billing.postalCode') }}</div>
          <div>{{ bp.postal_code }}</div>
          <div class="text-gray-500">{{ $t('billing.state') }}</div>
          <div>{{ bp.state }}</div>
          <div class="text-gray-500">{{ $t('billing.country') }}</div>
          <div>{{ bp.country }}</div>
        </div>
      </div>
    </div>
    <div v-else class="text-gray-400 text-center py-8">Nessun profilo di fatturazione</div>

    <!-- MODAL EDIT -->
    <div v-if="editPanel" class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50">
      <div class="absolute top-0 left-0 w-full h-full bg-black opacity-50" @click="editPanel = false"></div>
      <div class="bg-white rounded-lg shadow-lg z-50 w-full md:max-w-md sm:max-w-sm max-w-xs">
        <div class="p-4 font-bold">{{ $t('billing.updateBillingProfile') }}</div>
        <div class="bg-gray-100 border p-4 space-y-3">
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.name') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" :placeholder="editingBp.name" v-model="editForm.name" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.fiscalCode') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" :placeholder="editingBp.fiscal_code" v-model="editForm.fiscal_code" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.street') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" :placeholder="editingBp.line1" v-model="editForm.line1" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.city') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" :placeholder="editingBp.city" v-model="editForm.city" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.postalCode') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" :placeholder="editingBp.postal_code" v-model="editForm.postal_code" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.state') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" :placeholder="editingBp.state" v-model="editForm.state" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.country') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" :placeholder="editingBp.country" v-model="editForm.country" /></div>
        </div>
        <div class="p-4 flex justify-end text-sm gap-2">
          <button @click="editPanel = false" class="px-3 py-1 rounded-lg border shadow-sm">{{ $t('billing.cancel') }}</button>
          <button @click="saveEdit" class="px-3 py-1 rounded-lg border border-primary-800 shadow-sm text-gray-100 bg-primary-600">{{ $t('billing.update') }}</button>
        </div>
      </div>
    </div>

    <!-- MODAL CREATE -->
    <div v-if="createPanel" class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50">
      <div class="absolute top-0 left-0 w-full h-full bg-black opacity-50" @click="createPanel = false"></div>
      <div class="bg-white rounded-lg shadow-lg z-50 w-full md:max-w-md sm:max-w-sm max-w-xs">
        <div class="p-4 font-bold">Nuovo profilo di fatturazione</div>
        <div class="bg-gray-100 border p-4 space-y-3">
          <div><p class="my-1 text-sm text-gray-600">Nome</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" v-model="createForm.name" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.fiscalCode') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" v-model="createForm.fiscal_code" /></div>
          <div>
            <p class="my-1 text-sm text-gray-600">Tipo profilo</p>
            <select v-model="createForm.profile_type" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2">
              <option value="PRIVATE">Privato</option>
              <option value="BUSINESS">Azienda</option>
              <option value="FOREIGN">Estero</option>
            </select>
          </div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.street') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" v-model="createForm.line1" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.city') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" v-model="createForm.city" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.postalCode') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" v-model="createForm.postal_code" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.state') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" v-model="createForm.state" /></div>
          <div><p class="my-1 text-sm text-gray-600">{{ $t('billing.country') }}</p><input type="text" class="text-sm rounded-lg border border-gray-400 w-full py-1 px-2" v-model="createForm.country" /></div>
        </div>
        <div class="p-4 flex justify-end text-sm gap-2">
          <button @click="createPanel = false" class="px-3 py-1 rounded-lg border shadow-sm">{{ $t('billing.cancel') }}</button>
          <button @click="saveCreate" class="px-3 py-1 rounded-lg border border-primary-800 shadow-sm text-gray-100 bg-primary-600">Crea</button>
        </div>
      </div>
    </div>

    <!-- MODAL DELETE CONFERMA -->
    <div v-if="deletePanel" class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50">
      <div class="absolute top-0 left-0 w-full h-full bg-black opacity-50" @click="deletePanel = false"></div>
      <div class="bg-white rounded-lg shadow-lg z-50 w-full md:max-w-sm max-w-xs">
        <div class="p-4 font-bold">Elimina profilo di fatturazione</div>
        <div class="p-4 text-sm text-gray-700">
          Sei sicuro di voler eliminare il profilo <strong>{{ deletingBp.name }}</strong>? L'operazione non è reversibile.
        </div>
        <div class="p-4 flex justify-end text-sm gap-2">
          <button @click="deletePanel = false" class="px-3 py-1 rounded-lg border shadow-sm">Annulla</button>
          <button @click="confirmDelete" class="px-3 py-1 rounded-lg border border-red-600 shadow-sm text-gray-100 bg-red-500">Elimina</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default {
  setup() {
    const store = useStore();
    const route = useRoute();

    onMounted(() => store.dispatch('getUserBillingProfile', { id: route.params.id }));

    const billingProfiles = computed(() => store.getters.userBillingProfile);

    // ── EDIT ──
    const editPanel = ref(false);
    const editingBp = reactive({ id: '', name: '', fiscal_code: '', line1: '', city: '', postal_code: '', state: '', country: '' });
    const editForm = reactive({ name: '', fiscal_code: '', line1: '', city: '', postal_code: '', state: '', country: '' });

    const openEdit = (bp) => {
      Object.assign(editingBp, bp);
      Object.assign(editForm, { name: '', fiscal_code: '', line1: '', city: '', postal_code: '', state: '', country: '' });
      editPanel.value = true;
    };
    const saveEdit = () => {
      const body = Object.fromEntries(Object.entries(editForm).filter(([, v]) => v !== ''));
      if (!Object.keys(body).length) { editPanel.value = false; return; }
      store.dispatch('updateBillingProfile', { id: editingBp.id, body })
        .then((result) => { if (!result) return; editPanel.value = false; store.dispatch('getUserBillingProfile', { id: route.params.id }); });
    };

    // ── CREATE ──
    const createPanel = ref(false);
    const emptyCreate = () => ({ name: '', fiscal_code: '', profile_type: 'PRIVATE', line1: '', city: '', postal_code: '', state: '', country: '' });
    const createForm = reactive(emptyCreate());

    const openCreate = () => {
      Object.assign(createForm, emptyCreate());
      createPanel.value = true;
    };
    const saveCreate = () => {
      if (!createForm.name || !createForm.fiscal_code || !createForm.line1 || !createForm.city || !createForm.postal_code || !createForm.country) return;
      store.dispatch('createUserBillingProfile', { user: route.params.id, ...createForm })
        .then((result) => { if (!result) return; createPanel.value = false; store.dispatch('getUserBillingProfile', { id: route.params.id }); });
    };

    // ── DELETE ──
    const deletePanel = ref(false);
    const deletingBp = reactive({ id: '', name: '' });

    const openDelete = (bp) => {
      Object.assign(deletingBp, bp);
      deletePanel.value = true;
    };
    const confirmDelete = () => {
      store.dispatch('deleteUserBillingProfile', { id: deletingBp.id })
        .then((result) => { if (!result) return; deletePanel.value = false; store.dispatch('getUserBillingProfile', { id: route.params.id }); });
    };

    // ── FAVOURITE ──
    const setFavourite = (bp) => {
      if (bp.favourite) return;
      store.dispatch('setFavouriteBillingProfile', { id: bp.id })
        .then((result) => { if (!result) return; store.dispatch('getUserBillingProfile', { id: route.params.id }); });
    };

    return { billingProfiles, editPanel, editingBp, editForm, openEdit, saveEdit, createPanel, createForm, openCreate, saveCreate, deletePanel, deletingBp, openDelete, confirmDelete, setFavourite };
  },
};
</script>
